<div class="container">
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="sensors && sensors.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Office</th>
        <th class="text-center" scope="col">Relay Board</th>
        <th class="text-center" scope="col">Sensor Id</th>
        <th class="text-center" scope="col">Name</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let sensor of sensors">
        <td class="text-center">{{ sensor.id }}</td>
        <td class="text-center">{{ getOffice(sensor.officeId) }}</td>
        <td class="text-center">{{ getRelayBoard(sensor.relayBoardId) }}</td>
        <td class="text-center">{{ sensor.sensorId }}</td>
        <td class="text-center">{{ sensor.name }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger delete-button">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="!sensors || sensors.length == 0">
    <p>You have no sensors yet</p>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
